import React from 'react'
import cx from 'classnames'
import { FormattedMessage } from 'react-intl'
import { Text } from '@chakra-ui/react'

import styles from './Footnote.module.less'

export default function FootNote({ location, className }) {
  // TODO: Use actual version when we figure out where should it come from
  const appVersion = process.env.REACT_APP_VERSION

  const classNames = cx({
    [className]: !!className,
    [styles.poweredBySidebar]: location === 'sidebar',
    'powered-by': true,
  })

  return (
    <div className={classNames}>
      <Text variant='secondary' fontSize={'12px'} opacity={0.5}>
        <FormattedMessage id='app.poweredBy' defaultMessage='Powered by Pathway' />
        {appVersion && <span> | </span>}
        {appVersion && <span>{appVersion}</span>}
      </Text>
    </div>
  )
}
